import { StatusType } from "../Status/StatusType";

// Statusy, w których technik może edytować kwalifikację (od Przypisany edycja jest zablokowana).
export const QUALIFICATION_EDITABLE_STATUSES = [
  StatusType.qualification,
  StatusType.toAssign,
  StatusType.delayed,
];

// Klucz filtra kolejki kwalifikacji w tabeli głównej (Kwalifikacja + Odłożony, wszyscy technicy).
export const QUALIFICATION_QUEUE_FILTER = "qualificationQueue";

// Opcje decyzji: pole BE -> klucz tłumaczenia (z domyślnym polskim tekstem).
export const QUALIFICATION_OPTIONS = [
  {
    field: "requiresAssignment",
    label: "global:qualification.requiresAssignment",
    defaultLabel: "Wymaga przypisania",
    status: StatusType.toAssign,
  },
  {
    field: "delayOrder",
    label: "global:qualification.delayOrder",
    defaultLabel: "Odłóż zlecenie",
    status: StatusType.delayed,
  },
  {
    field: "performRemotelyNow",
    label: "global:qualification.performRemotelyNow",
    defaultLabel: "Wykonaj zdalnie teraz",
    status: StatusType.assigned,
  },
];

// Zwraca opcję decyzji wynikającą z flag rekordu (zlecenia lub wpisu historii) albo undefined.
export const getQualificationDecision = (record) =>
  QUALIFICATION_OPTIONS.find((option) => Boolean(record?.[option.field]));

// Zwraca "Imię Nazwisko" pracownika (qualificationAuthor).
export const formatWorkerName = (worker) =>
  worker ? `${worker.firstName || ""} ${worker.lastName || ""}`.trim() : "";
